/**
 * @file 言語データ：日本語 定数管理
 */

export const ja = {
    name: "日本語",
    viewThisCase: "この症例を日本語で見る",
};
